import { IToolingPlantCostDetailsByPID } from "@redux/reducers/toolingPlantCostReducer";

export enum ActionType {
  TOOLING_PLAN_COST_DETAILS_BY_PID = "TOOLING_PLAN_COST_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IToolingPlantCostDetailsById {
  type: ActionType.TOOLING_PLAN_COST_DETAILS_BY_PID;
  payload: IToolingPlantCostDetailsByPID[];
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IToolingPlantCostDetailsById | IResetReduxState;
